import axios from "axios";
import { auth } from "./firebase";

const api = axios.create({
  baseURL: "http://localhost:8000",
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para añadir el token de Firebase a las peticiones
api.interceptors.request.use(
  async (config) => {
    // Ensure URLs always have a leading slash for consistency
    if (
      config.url &&
      !config.url.startsWith("/") &&
      !config.url.startsWith("http")
    ) {
      config.url = `/${config.url}`;
    }

    // Si es una petición de login o register usando Firebase, no necesitamos configurar headers especiales
    // ya que la autenticación se maneja a través de Firebase

    try {
      // Obtener el usuario actual de Firebase
      const currentUser = auth.currentUser;

      // Si hay un usuario autenticado, obtener su token y añadirlo al header
      if (currentUser) {
        const token = await currentUser.getIdToken(true);
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        // Usar el token almacenado en localStorage como fallback (compatibilidad)
        const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error("Error al obtener el token de Firebase:", error);

      // En caso de error, intentar usar el token de localStorage como fallback
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // No hacer nada si no hay respuesta (error de red o servidor no disponible)
    // Esto permitirá que la app siga funcionando sin desloguear al usuario
    // cuando hay problemas de conectividad
    if (!error.response) {
      console.error("Network error, server might be down:", error.message);
      return Promise.reject(error);
    }

    // Si el error es 401 (Unauthorized) y no estamos intentando hacer login
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/login")
    ) {
      console.log("Unauthorized request, redirecting to login");

      // Marcamos la petición como reintentada para evitar bucle infinito
      originalRequest._retry = true;

      // Limpiar el almacenamiento local y cerrar sesión en Firebase
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("premiumType");

      try {
        // Cerrar sesión en Firebase
        await auth.signOut();
      } catch (signOutError) {
        console.error("Error al cerrar sesión en Firebase:", signOutError);
      }

      // Si estamos en una SPA, redirigir al login pero preservar la URL actual
      // para redireccionar después de iniciar sesión
      if (typeof window !== "undefined") {
        const currentPath = window.location.pathname + window.location.search;

        // Solo guardamos la ruta si no es la de login
        if (!currentPath.includes("/login")) {
          localStorage.setItem("redirectAfterLogin", currentPath);
        }

        // Redireccionar al login con un parámetro de error
        window.location.href = "/login?error=session_expired";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
